import React from 'react'

function AboutFive() {
  return (
    <div>
      <section className="about-five about-six">
        <div className="about-six-shape-1" />
        <div className="about-six-shape-2" />
        <div className="container">
          <div className="about-four-title-box">
            <div
              className="section-three-title wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-three-title-title text-center">
                <h2>
                  Grow Leads and Sales with insanely Good SEO Strategy
                </h2>
              </div>
            </div>
            <div
              className="section-three-details text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <p>
                Digital marketing &amp; advertising approach focuses on
                capturing the essential
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <div className="about-five-single-icon-box icon-box-1">
                  <i className="icon-keyword-3" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Keyword Research</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="about-five-single-icon-box icon-box-2">
                  <i className="icon-Group" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Web Optimization</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div className="about-five-single-icon-box icon-box-3">
                  <i className="icon-search-location-1" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Enterprise SEO</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="about-five-single-icon-box icon-box-4">
                  <i className="icon-data-1-1" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Competitive Analysis</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                <div className="about-five-single-icon-box icon-box-5">
                  <i className="icon-insight1" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Reporting Dashboard</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
              <div
                className="about-five-single-box about-six-single-box text-center wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="600ms"
              >
                <div className="about-five-single-icon-box icon-box-6">
                  <i className="icon-technical-support-1" />
                </div>
                <div className="about-five-single-title-box">
                  <h3>Technical Audit</h3>
                </div>
                <div className="about-five-single-detail-box">
                  <p>
                    Nemo enim voluptatem voluptas aspernatur aut fugit
                    consequuntur dolores
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12" />
          </div>
        </div>
      </section>
    </div>
  )
}

export default AboutFive
